import { render, staticRenderFns } from "./InvestmentsLanding.vue?vue&type=template&id=0fbc0464&scoped=true&"
import script from "./InvestmentsLanding.vue?vue&type=script&lang=js&"
export * from "./InvestmentsLanding.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentsLanding.vue?vue&type=style&index=0&id=0fbc0464&scoped=true&lang=scss&"
import style1 from "./InvestmentsLanding.vue?vue&type=style&index=1&id=0fbc0464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc0464",
  null
  
)

export default component.exports